<nav class="library-nav-wrapper" role="navigation">
  @if (vm$ | async; as vm) {
    <app-library-navigation-node [pathInfo]="vm.pathInfo" [canEdit]="vm.isEditor" [expanded]="true" [node]="vm.root" />
  }
</nav>
